<template>
  <div class="my-userInfo-body">
    <div class="my-userInfo-cont" v-if="isLogin">
      <div @click="checkItem('/myPage')" class="my-userInfo-item my-userInfo-item1">
      <!-- <div @click="checkItem('/dingWorkbench')" class="my-userInfo-item my-userInfo-item1" :class="userInfo.logoFileUrl?'my-userInfo-col':''"> -->
        <!-- <img v-if="userInfo.logoFileUrl" :src="userInfo.logoFileUrl" alt="">
        <span v-else>{{getTrueName}}</span> -->
        <span>{{getTrueName}}</span>
      </div>
      <div @click="checkItem('/myPage')" class="my-userInfo-item my-userInfo-item2" :class="activeItem=='/myPage'?'userInfo-active':''">
        <span class="mr5">{{userInfo.trueName}}</span><span v-if="userInfo.trueNameEn">({{userInfo.trueNameEn}})</span>
      </div>
    </div>
    <div class="my-userInfo-cont" @click="checkItem('/myPage')" v-else>
      <div class="my-userInfo-item my-userInfo-item1 my-userInfo-item3">
        <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/icons_header.svg" alt="">
      </div>
      <div class="my-userInfo-item my-userInfo-item2">
        <span class="mr5">登录</span>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  export default {
    props: ['show'],
    data () {
      return {
        activeItem:'',
        isLogin:false,
        userInfo:{

        }
      }
    },
    components: {
    },
    computed:{
      ...mapState([
        'KP'
      ]),
      getTrueName(){
        let name=this.userInfo.trueName
        name=name?name.length<=2?name:name.substring(name.length-2):""
        if(this.userInfo.trueName&&this.userInfo.trueName.split(' ').length>1){
          name=this.userInfo.trueName.split(' ')[this.userInfo.trueName.split(' ').length-1]
        }
        return name
      }
    },
    created () {
    },
    mounted () {

      // console.info(this.getToken('isLogin'))
      this.isLogin=this.getToken('isLogin')=='100'?true:false
      let userInfo = this.getDAesString(this.getToken('userInfo'),this.KP.key,this.KP.iv) || "{}"
      this.userInfo = JSON.parse(userInfo)
      // console.info(this.userInfo,'this.userInfo')
    },
    methods: {
      checkItem(url){
        this.$router.push({
          path:url
        })
      }
    }
  }
</script>
<style>
  .my-userInfo-body{
    position: absolute;
    top: 0;
    left:0;
    width: 100%;
    background: #fff;
    text-align: center;
    padding-top:10px;
    padding-bottom:10px;
    color:#606266;
    font-size: 14px;
    z-index: 100;
    /* box-shadow: 0 2px 6px 0 rgba(0,0,0,0.06); */
  }
  .my-userInfo-body .mr5{
    margin-right: 5px;
  }
  .my-userInfo-body .my-userInfo-cont{
    padding: 0 15px;
    display: flex;
    justify-content: flex-end;
  }
  .my-userInfo-body .my-userInfo-item{
    align-items: center;
    line-height: 32px;
  }
  .my-userInfo-body .my-userInfo-item1{
    margin-right: 10px;
    width: 32px;
    height: 32px;
    text-align: center;
    overflow: hidden;
    background: #A98463 ;
    border-radius:32px;
    color:#fff;
    font-size: 12px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .my-userInfo-body .my-userInfo-col{
    background: #fff ;
  }
  .my-userInfo-body .my-userInfo-item1 img{
    
    width: 32px;
    height: 32px;
    border-radius: 32px;
  }
  .my-userInfo-body .my-userInfo-item3 img{
    width: 18px;
    height: 18px;
    border-radius: 0;
  }
  .my-userInfo-body .my-userInfo-item3 {
    background:#DCDFE6;
  }

</style>


// WEBPACK FOOTER //
// src/pages/dingWorkbench/components/userInfo.vue